import { get, post, put, deleteApi, postForm } from "../../api/index";
import { API_ENDPOINTS } from "../../constants";
import { readDataFromLocalStorage } from "../../utils/globalUtils";

const { APIS } = API_ENDPOINTS;

/*
==========================================
        Profile Settings Services
==========================================
*/

export const getProfileInfoService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.USERPROFILE}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const uploadProfilePictureService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.USERS}/picture`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAccountSettingsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ORGS}/settings`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountInfoService = data =>
  new Promise((resolve, reject) => {
    put(`${APIS.ORGS}/settings/info`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountPictureService = data =>
  new Promise((resolve, reject) => {
    console.debug(data);
    postForm(`${APIS.ORGS}/logo`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountEmailService = data =>
  new Promise((resolve, reject) => {
    put(`${APIS.ORGS}/settings/email`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const addAccountAddressService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.ORGS}/address`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteAccountAddressService = id =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.ORGS}/address/${id}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountAddressService = (id, data) =>
  new Promise((resolve, reject) => {
    put(`${APIS.ORGS}/address/${id}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
        Authentication Settings Services
==========================================
*/

export const getSAMLSettingsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.SAML_SETTINGS}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateSAMLSettingsService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.SAML_SETTINGS}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const uploadSAMLCertificateService = data =>
  new Promise((resolve, reject) => {
    postForm(`${APIS.UPLOAD_SAML_CERTIFICATE}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
        Billing Settings Services
==========================================
*/

export const getBillingInfo = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.BILLING_INFO}`)
      .then(response => {
        resolve(response && response.billing_details);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getBillingInvoice = invoiceId =>
  new Promise((resolve, reject) => {
    get(`${APIS.BILLING_INVOICE}/${invoiceId}/pdf`)
      .then(response => {
        resolve(response && response.invoice_url);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getChargeBeeCheckoutUrl = planName =>
  new Promise((resolve, reject) => {
    get(`${APIS.CHARGEBEE_CHECKOUT_URL}/${planName}`)
      .then(response => {
        resolve(response && response.checkout_url);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getChargeBeePaymentUrl = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.CHARGEBEE_PAYMENT_URL}`)
      .then(response => {
        resolve(response && response.payment_url);
      })
      .catch(error => {
        reject(error);
      });
  });

export const subscriptionCheckout = payload =>
  new Promise((resolve, reject) => {
    const userInfo = readDataFromLocalStorage("revvsalesUser");
    post(`${APIS.STRIPE_BILLING_CHECKOUT}`, {
      name: `${userInfo.first_name} ${userInfo.last_name}`,
      user_email: userInfo.user_email,
      price_id: payload,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const stripePortalURL = () =>
  new Promise((resolve, reject) => {
    const userInfo = readDataFromLocalStorage("revvsalesUser");
    post(`${APIS.STRIPE_BILLING_PORTAL}`, {
      name: `${userInfo.first_name} ${userInfo.last_name}`,
      user_email: userInfo.user_email,
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const stripeLastPayment = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.STRIPE_BILLING_PAYMENT}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const invokeStripe = () => {
  // stripe promise
  const stripePromise = window.Stripe(
    `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`,
  );
  return stripePromise;
};

/*
==========================================
     Revv Oauth  Settings Services
==========================================
*/

export const getRevvOauthAppsService = () =>
  new Promise((resolve, reject) =>
    get(`${APIS.REVV_OAUTH}`)
      .then(response => {
        resolve((response && response.Applications) || []);
      })
      .catch(error => {
        reject(error);
      }),
  );

export const createRevvOauthAppService = appName =>
  new Promise((resolve, reject) =>
    post(`${APIS.REVV_OAUTH}`, appName)
      .then(response => {
        resolve((response && response.Application) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const createRevvOauthClientService = (appID, url) =>
  new Promise((resolve, reject) =>
    post(`${APIS.REVV_OAUTH}${appID}/clients/`, url)
      .then(response => {
        resolve((response && response.Client) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const updateRevvOauthClientService = (clientID, url) =>
  new Promise((resolve, reject) =>
    put(`${APIS.REVV_OAUTH_CLIENT}${clientID}`, url)
      .then(response => {
        resolve((response && response.Client) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );

export const deleteRevvOauthClientService = clientID =>
  new Promise((resolve, reject) =>
    deleteApi(`${APIS.REVV_OAUTH_CLIENT}${clientID}`)
      .then(response => {
        resolve((response && response.Application) || {});
      })
      .catch(error => {
        reject(error);
      }),
  );



// WEBPACK FOOTER //
// ./src/actions/SettingsActions/settingsService.js